import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { UpdateFinanceIndividual } from "src/app/parametrage/core/model/individual/update-finance-individual";

@Component({
  selector: "app-update-finance-individual",
  templateUrl: "./update-finance-individual.component.html",
  styleUrls: ["./update-finance-individual.component.scss"],
})
export class UpdateFinanceIndividualComponent implements OnInit {
  @Input() individualId;

  individual: Individual;

  customer: UpdateFinanceIndividual = new UpdateFinanceIndividual();

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _individualService: IndividualService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      salaireEmprunteur: [
        0,
        [
          Validators.compose([Validators.required]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      salaireConjoint: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantLoyer: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantAutreRevenu: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],

      totalEngagementActuel: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      chargeEmpruntSollicite: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      montantBonusDat: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      primeTrimestrielle: [
        0,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
          Validators.min(0),
        ],
      ],
      domiciliationSalaire: [true, Validators.compose([Validators.required])],

    });
  }

  ngOnInit() {
    this.getIndividualById(this.individualId);
  }

  getIndividualById(individualId) {
    this._individualService.getIndividualById(individualId).subscribe(
      (data) => {
        this.individual = data;
        this.customer.individualId = this.individual.id;
        this.customer.montantAutreRevenu = this.individual.montantAutreRevenu;
        this.customer.montantLoyer = this.individual.montantLoyer;
        this.customer.salaireConjoint = this.individual.salaireConjoint;
        this.customer.salaireEmprunteur = this.individual.salaireEmprunteur;

        this.customer.totalEngagementActuel = this.individual.totalEngagementActuel;
        this.customer.chargeEmpruntSollicite = this.individual.chargeEmpruntSollicite;
        this.customer.montantBonusDat = this.individual.montantBonusDat;
        this.customer.primeTrimestrielle = this.individual.primeTrimestrielle;
        this.customer.domiciliationSalaire = this.individual.domiciliationSalaire;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this._individualService
      .updateFinance(this.customer)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
